
<div class="index-panel">
  <align
    v-show="loaded"
    small-gap
    flex
    class="header"
  >
    <align>
      <index-image :index="index" />

      <div>
        <h1 class="secondary-font">
          {{ index.label }}
        </h1>
        <p v-if="index.description">
          {{ index.description }}
        </p>
      </div>
    </align>

    <icon-button
      v-if="index.custom"
      icon="delete"
      tooltip="Delete Custom Index"
      @click="deleteCustomIndex"
    />

    <icon-button
      v-else-if="isStaff && isPlayerIndex"
      icon="refresh"
      tooltip="Refresh Index"
      :loading="refreshing"
      @click="refreshIndex"
    />
  </align>

  <template v-if="loaded">
    <div class="tabs">
      <tab :active="display === 'stats'" @click="display = 'stats'">
        Stats
      </tab>

      <tab :active="display === 'cards'" @click="display = 'cards'">
        Cards
      </tab>
    </div>

    <div class="wrapper">
      <index-stats-view
        v-if="display === 'stats'"
        :index="index"
      />

      <index-cards-view
        v-show="display === 'cards'"
        :active="display === 'cards'"
        :index-filters="filters"
      />
    </div>
  </template>

  <spinner v-else />
</div>
